<template>
    <div>
        {{ error }}
        <h2>{{ album.name }}</h2>        
        <i>Version: {{ album.version }}, Last update: {{ album.updateDateTime | formatDate }}</i>
        <hr/>
        <div class="md-form mt-0 row">                
                <button class="btn btn-info" type="submit" v-on:click="refresh">Refresh</button>
        </div>

        <form>
            <div class="row">
                <div class="col-sm-6 form-group">
                    <div class="form-group">
                        <label for="name" class="col-sm4 col-form-label">Name</label>
                        <div class="col-sm-8">
                            <input id="name" class="form-control" type="text" v-model="album.name" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="artist" class="col-sm4 col-form-label">Artist</label>
                        <div class="col-sm-8">
                            <input id="artist" class="form-control" type="text" v-model="album.artist" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="year" class="col-sm4 col-form-label">Year</label>
                        <div class="col-sm-8">
                            <input id="year" class="form-control" type="text" v-model="album.year" />
                        </div>
                    </div>          
                    <div class="form-group">
                        <label for="releaseDate" class="col-sm4 col-form-label">Release date</label>
                        <div class="col-sm-8">
                            <input id="releaseDate" class="form-control" type="text" v-model="album.releaseDate" />
                        </div>
                    </div>      
                    <div class="form-group">
                        <label for="releaseFormat" class="col-sm4 col-form-label">Release format</label>
                        <div class="col-sm-8">
                            <input id="releaseFormat" class="form-control" type="text" v-model="album.releaseFormat" />
                        </div>
                    </div>                      
                    <div class="form-group">
                        <label for="genre" class="col-sm4 col-form-label">Genre</label>
                        <div class="col-sm-8">
                            <input id="genre" class="form-control" type="text" v-model="album.genre" />
                        </div>
                    </div>          
                    <div class="form-group">
                        <label for="label" class="col-sm4 col-form-label">Label</label>
                        <div class="col-sm-8">
                            <input id="label" class="form-control" type="text" v-model="album.label" />
                        </div>
                    </div>          
                    <div class="form-group">
                        <label for="score" class="col-sm4 col-form-label">Score</label>
                        <div class="col-sm-8">
                            <input id="score" class="form-control" type="text" v-model="album.score" />
                        </div>
                    </div>          
                    <div class="form-group">
                        <label for="speed" class="col-sm4 col-form-label">Speed</label>
                        <div class="col-sm-8">
                            <input id="speed" class="form-control" type="text" v-model="album.speed" />
                        </div>
                    </div>          
                    <div class="form-group">
                        <label for="theme" class="col-sm4 col-form-label">Theme</label>
                        <div class="col-sm-8">
                            <input id="theme" class="form-control" type="text" v-model="album.theme" />
                        </div>
                    </div>          
                    <div class="form-group">
                        <label for="mood" class="col-sm4 col-form-label">Mood</label>
                        <div class="col-sm-8">
                            <input id="mood" class="form-control" type="text" v-model="album.mood" />
                        </div>
                    </div>    
                    <div class="form-group">
                        <label for="sales" class="col-sm4 col-form-label">Sales</label>
                        <div class="col-sm-8">
                            <input id="sales" class="form-control" type="text" v-model="album.sales" />
                        </div>
                    </div>    

                    <div class="form-group">
                        <label for="wikipedia" class="col-sm4 col-form-label">Wikipedia</label>
                        <div class="col-sm-8">
                            <input id="wikipedia" class="form-control" type="text" v-model="album.wikipedia" />
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="biography" class="col-sm4 col-form-label">Biography</label>
                        <div class="col-sm-8">
                            <textarea id="biography" class="form-control" rows="6" v-model="album.biography" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="biographyFR" class="col-sm4 col-form-label">Biography FR</label>
                        <div class="col-sm-8">
                            <textarea id="biographyFR" class="form-control" rows="6" v-model="album.biographyFR" />
                        </div>
                    </div>              
                    <h3>IDs</h3>
                    <div class="form-group">
                        <label for="releaseGroupMusicBrainzID" class="col-sm4 col-form-label"><a :href="'https://musicbrainz.org/release/' + album.releaseGroupMusicBrainzID" target="_blank">MusicBrainz release group ID</a></label>
                        <div class="col-sm-8">
                            <input id="releaseGroupMusicBrainzID" class="form-control" type="text" v-model="album.releaseGroupMusicBrainzID" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="musicBrainzID" class="col-sm4 col-form-label"><a :href="'https://musicbrainz.org/release/' + album.musicBrainzID" target="_blank">MusicBrainz ID</a></label>
                        <div class="col-sm-8">
                            <input id="musicBrainzID" class="form-control" type="text" v-model="album.musicBrainzID" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="musicBrainzArtistID" class="col-sm4 col-form-label"><a :href="'https://musicbrainz.org/artist/' + album.musicBrainzArtistID" target="_blank">MusicBrainz ID artist</a></label>
                        <div class="col-sm-8">
                            <input id="musicBrainzArtistID" class="form-control" type="text" v-model="album.musicBrainzArtistID" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="audioDbID" class="col-sm4 col-form-label">AudioDb ID</label>
                        <div class="col-sm-8">
                            <input id="audioDbID" class="form-control" type="text" v-model="album.audioDbID" />
                        </div>
                    </div>    
                    <div class="form-group">
                        <label for="audioDbArtistID" class="col-sm4 col-form-label">AudioDb ID artist</label>
                        <div class="col-sm-8">
                            <input id="audioDbArtistID" class="form-control" type="text" v-model="album.audioDbArtistID" />
                        </div>
                    </div>    
                    <div class="form-group">
                        <label for="allMusicID" class="col-sm4 col-form-label">Allmusic ID</label>
                        <div class="col-sm-8">
                            <input id="allMusicID" class="form-control" type="text" v-model="album.allMusicID" />
                        </div>
                    </div>    
                    <div class="form-group">
                        <label for="discogsID" class="col-sm4 col-form-label">Discogs ID</label>
                        <div class="col-sm-8">
                            <input id="discogsID" class="form-control" type="text" v-model="album.discogsID" />
                        </div>
                    </div>  
                    <div class="form-group">
                        <label for="musicMozID" class="col-sm4 col-form-label">MusicMoz ID</label>
                        <div class="col-sm-8">
                            <input id="musicMozID" class="form-control" type="text" v-model="album.musicMozID" />
                        </div>
                    </div>   
                    <div class="form-group">
                        <label for="lyricWikiID" class="col-sm4 col-form-label">LyricWiki ID</label>
                        <div class="col-sm-8">
                            <input id="lyricWikiID" class="form-control" type="text" v-model="album.lyricWikiID" />
                        </div>
                    </div>   
                    <div class="form-group">
                        <label for="geniusID" class="col-sm4 col-form-label">GeniusID ID</label>
                        <div class="col-sm-8">
                            <input id="geniusID" class="form-control" type="text" v-model="album.geniusID" />
                        </div>
                    </div>   
                    <div class="form-group">
                        <label for="wikipediaID" class="col-sm4 col-form-label"><a :href="'https://wikipedia.org/wiki/' + album.wikipediaID" target="_blank">Wikipedia ID</a></label>
                        <div class="col-sm-8">
                            <input id="wikipediaID" class="form-control" type="text" v-model="album.wikipediaID" />
                        </div>
                    </div>   
                    <div class="form-group">
                        <label for="wikidataID" class="col-sm4 col-form-label"><a :href="'https://www.wikidata.org/wiki/' + album.wikidataID" target="_blank">Wikidata ID</a></label>
                        <div class="col-sm-8">
                            <input id="wikidataID" class="form-control" type="text" v-model="album.wikidataID" />
                        </div>
                    </div>   
                    <div class="form-group">
                        <label for="amazonID" class="col-sm4 col-form-label">Amazon ID</label>
                        <div class="col-sm-8">
                            <input id="amazonID" class="form-control" type="text" v-model="album.amazonID" />
                        </div>
                    </div>   
                </div>
                
                <div class="col-sm-6 form-group">
                    <h3>Cover</h3>
                    <div class="form-group">                        
                        <div class="col-sm-4">                                                
                            <picture-input 
                                id="coverInput"   
                                ref="coverInput"       
                                @change="onChangePicture"
                                :prefill="coverUrl"
                                :prefillOptions="{ fileName: 'cover.jpg', fileType: 'png', mediaType: 'image/jpg'}"
                                size=0
                                margin="16"                                                                 
                                button-class="btn btn-primary"
                                :custom-strings="{ drag: 'Drag a picture' }"
                                >                                
                            </picture-input>
                        </div>
                    </div>               
                </div>          
            </div>
        </form>
    </div>
</template>

<script>
    
    import ApiClient from '@/tools/apiClient.js';
    import PictureInput from '@/components/Picture-input.vue';

    let api = new ApiClient();

    export default {
        name: 'album',            
        data: function () {
            return {
                album: '', 
                error: '',
                coverUrl: ''
            }
        },
        components: {
          PictureInput  
        },

        created: async function () {
            
            let albumID = this.$route.params.id;

            this.album = await api.getAlbumAsync( albumID );
            this.coverUrl = process.env.VUE_APP_API_BASE_URL + '/v2/albums/cover/' + this.album.musicBrainzID;
        },

        methods: {   
            refresh: async function() {                                    
                this.album = await api.refreshAlbumAsync( this.album.releaseGroupMusicBrainzID );                                
            },

            onChangePicture: async function(sender) {

                if(sender == 'coverInput')                 
                    await api.postCoverAsync(this.album.musicBrainzID, this.$refs.coverInput.file);        
            }            
        },
    }
</script>